package com.downdogapp.client.controllers.menu

import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Key
import com.downdogapp.client.singleton.UserPrefs
import com.downdogapp.client.views.menu.createLanguageView

class LanguageViewController : ViewController() {

  override val view = createLanguageView(
    selectedIndex = MANIFEST.languageOptions.indexOfFirst { it.value == Strings.language },
    controller = this
  )

  override fun onBackgrounded() {
    onBackClicked()
  }

  fun onSubmitClicked() {
    UserPrefs[Key.Language] = MANIFEST.languageOptions[view.selectedIndex].value.name
    view.spinnerShowing = true
    App.fetchManifest {
      view.spinnerShowing = false
      onBackClicked()
    }
  }
}
